import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, change } from 'redux-form';

import { renderLegacyTextField, LrenderSwitch, renderPasswordField } from '../../utils/engageComponents';

// Engage Actions 
import { UpdateCommunyV2 } from '../../actions/communityActions';

//Material components
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

export class ManagementIntegration extends Component {

    constructor(props) {
        super(props);
        
        this.state = {
            showPassword: false,
            community: props.communityInfo,
            entertain360: props.communityInfo ? props.communityInfo.entertain360 : undefined,
            coroHealth: props.communityInfo ? props.communityInfo.coroHealth : undefined,
            worxHub: props.communityInfo ? props.communityInfo.worxHub : undefined,
            tels: props.communityInfo ? props.communityInfo.tels : undefined,
            worxHubActive: props.communityInfo ? props.communityInfo.worxHub.active : false,
            coroHealthActive: props.communityInfo ? props.communityInfo.coroHealth.active : false,
            entertain360Active: props.communityInfo ? props.communityInfo.entertain360.active : false,
            telsActive: props.communityInfo ? props.communityInfo.tels.active : false
        };

        this.loadIntegrationView(props.communityInfo);


    }

    componentWillReceiveProps(nextProps) {

        let communityId = this.state.community ? this.state.community._id : undefined
        if (communityId === undefined || communityId !== nextProps.communityInfo._id) {
            this.setState(
                {
                    community: nextProps.communityInfo,
                    entertain360: nextProps.communityInfo ? nextProps.communityInfo.entertain360 : { active : false },
                    coroHealth: nextProps.communityInfo ? nextProps.communityInfo.coroHealth : { active : false } ,
                    worxHub: nextProps.communityInfo ? nextProps.communityInfo.worxHub : { active : false } ,
                    tels: nextProps.communityInfo ?  nextProps.communityInfo.tels : { active : false },
                    entertain360Active: nextProps.communityInfo ? nextProps.communityInfo.entertain360.active : false,
                    coroHealthActive: nextProps.communityInfo ? nextProps.communityInfo.coroHealth.active : false,
                    worxHubActive: nextProps.communityInfo ? nextProps.communityInfo.worxHub.active : false,
                    telsActive: nextProps.communityInfo ? nextProps.communityInfo.tels.active : false
                }
            );

            this.loadIntegrationView(nextProps.communityInfo ? nextProps.communityInfo : undefined);

        } else if (communityId === nextProps.communityInfo._id) {
            this.props.dispatch(change('ManagementIntegration', 'entertain360.active', this.state.entertain360Active));
            this.props.dispatch(change('ManagementIntegration', 'worxHub.active', this.state.worxHubActive));
            this.props.dispatch(change('ManagementIntegration', 'tels.active', this.state.telsActive));
            this.props.dispatch(change('ManagementIntegration', 'coroHealth.active', this.state.coroHealthActive));
            //this.props.dispatch(change('ManagementIntegration', 'isVoiceAvailable', this.state.isVoiceAvailable));
        }

    }


    loadIntegrationView (communityInfo){
        if (communityInfo) {
            let community = communityInfo;
            this.props.dispatch(change('ManagementIntegration', '_id', community._id));
            this.props.dispatch(change('ManagementIntegration', 'entertain360.active', community.entertain360.active));
            this.props.dispatch(change('ManagementIntegration', 'entertain360.name', community.entertain360.name));
            this.props.dispatch(change('ManagementIntegration', 'coroHealth.active', community.coroHealth.active));
            this.props.dispatch(change('ManagementIntegration', 'coroHealth.name', community.coroHealth.name));
            this.props.dispatch(change('ManagementIntegration', 'coroHealth.password', community.coroHealth.password));
            this.props.dispatch(change('ManagementIntegration', 'worxHub.active', community.worxHub.active));
            this.props.dispatch(change('ManagementIntegration', 'worxHub.partnerId', community.worxHub.partnerId));
            this.props.dispatch(change('ManagementIntegration', 'worxHub.partnerKey', community.worxHub.partnerKey));
            this.props.dispatch(change('ManagementIntegration', 'worxHub.thwInstance', community.worxHub.thwInstance));
            this.props.dispatch(change('ManagementIntegration', 'worxHub.thwSite', community.worxHub.thwSite));
            this.props.dispatch(change('ManagementIntegration', 'tels.active', community.tels.active));
            this.props.dispatch(change('ManagementIntegration', 'tels.businessUnitId', community.tels.businessUnitId));
            this.props.dispatch(change('ManagementIntegration', 'tels.refreshToken', community.tels.refreshToken));
        } else {
            this.props.dispatch(change('ManagementIntegration', 'entertain360.active', false));
            this.props.dispatch(change('ManagementIntegration', 'entertain360.name', ''));
            this.props.dispatch(change('ManagementIntegration', 'coroHealth.active', false));
            this.props.dispatch(change('ManagementIntegration', 'coroHealth.name', ''));
            this.props.dispatch(change('ManagementIntegration', 'coroHealth.password', ''));
            this.props.dispatch(change('ManagementIntegration', 'worxHub.active', false));
            this.props.dispatch(change('ManagementIntegration', 'worxHub.partnerId', ''));
            this.props.dispatch(change('ManagementIntegration', 'worxHub.partnerKey', ''));
            this.props.dispatch(change('ManagementIntegration', 'worxHub.thwInstance', ''));
            this.props.dispatch(change('ManagementIntegration', 'worxHub.thwSite', ''));
            this.props.dispatch(change('ManagementIntegration', 'tels.active', false));
            this.props.dispatch(change('ManagementIntegration', 'tels.businessUnitId', ''));
            this.props.dispatch(change('ManagementIntegration', 'tels.refreshToken', ''));
        }
    }
    
    async onSubmitHandler(formData) {
        if (formData._id) {
            const data = {
                entertain360 : {
                    active: this.state.entertain360Active,
                    name: formData.entertain360.name
                },
                coroHealth : {
                    active: this.state.coroHealthActive,
                    name: formData.coroHealth.name,
                    password: formData.coroHealth.password
                },
                worxHub : {
                    active: this.state.worxHubActive,
                    partnerId : formData.worxHub.partnerId,
                    partnerKey : formData.worxHub.partnerKey,
                    thwInstance : formData.worxHub.thwInstance,
                    thwSite : formData.worxHub.thwSite
                },
                tels : {
                    active : this.state.telsActive,
                    businessUnitId : formData.tels.businessUnitId,
                    refreshToken : formData.tels.refreshToken
                }
            }
            const stylesObj = {modalStyles:{backgroundColor: '#ffffff'}, messageClass:'LAlertMessageStyles'};
            await this.props.UpdateCommunyV2(formData._id, data , stylesObj);
        }
    };

    handleShowPassword = () => {
        this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
    };

    render() {
        return (
            <>
                <div id="save_integration_btn" className="appbtn-engage skybluebtn-engage" style={{ display: 'none' }} onClick={this.props.handleSubmit(this.onSubmitHandler.bind(this))}>
                    Save
                </div>
                <Grid container spacing={2} style={{ marginTop: '30px' }} >
                    {/* Entertain */}
                    <Grid item xs={5} sm={5} md={5} >
                        <Grid container direction='column'>
                            <Grid item xs={12} >
                                <Grid container className='LsetUpGridColum' direction='colum'>
                                    <Grid item xs={2} sm={2} md={2} style={{ padding: '10px', textAlign: 'right' }}>
                                        <Field
                                            idToSet='setup_integration_entrateinId_switch'
                                            name="entertain360.active"
                                            checked={this.state.entertain360Active}
                                            onClick={() => {
                                                this.setState((prevState) => (
                                                    { entertain360Active: !prevState.entertain360Active }))
                                            }}
                                            component={LrenderSwitch}
                                        />
                                    </Grid>
                                    <Grid item xs={9} sm={9} md={9} className="LVoiceTitle" style={{ padding: '10px', textAlign: 'left' }}>
                                        Entertain
                                    </Grid>
                                    <Grid item xs={2} sm={2} md={2}>
                                    </Grid>
                                    <Grid item xs={9} style={{ padding: '10px' }}>
                                        <Field
                                            id='setup_integration_entrateinId'
                                            name="entertain360.name"
                                            label="Entertain ID"
                                            maxLength={20}
                                            inputClass='setupInfoSection'
                                            component={renderLegacyTextField}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    {/* CoroHealth */}
                    <Grid item xs={5} sm={5} md={5}>
                        <Grid container direction='column'>
                            <Grid item xs={12} >
                                <Grid container className='LsetUpGridColum' direction='colum'>
                                    <Grid item xs={2} sm={2} md={2} style={{ padding: '10px', textAlign: 'right' }}>
                                        <Field
                                            idToSet='setup_integration_corohealth_switch'
                                            name="coroHealth.active"
                                            checked={this.state.coroHealthActive}
                                            onClick={() => {
                                                this.setState((prevState) => (
                                                    { coroHealthActive: !prevState.coroHealthActive }))
                                            }}
                                            component={LrenderSwitch}
                                        />
                                    </Grid>
                                    <Grid item xs={9} sm={9} md={9} className="LVoiceTitle" style={{ padding: '10px', textAlign: 'left' }}>
                                        Coro Health
                                    </Grid>
                                    <Grid item xs={2} sm={2} md={2}>
                                    </Grid>
                                    <Grid item xs={9} style={{ padding: '10px' }}>
                                        <Field
                                            id='setup_integration_corohealth_username'
                                            name="coroHealth.name"
                                            label="Username"
                                            maxLength={20}
                                            inputClass='setupInfoSection'
                                            component={renderLegacyTextField}
                                        />
                                    </Grid>
                                    <Grid item xs={2} sm={2} md={2}>
                                    </Grid>
                                    <Grid item xs={9} style={{ padding: '10px', position: 'relative' }}>
                                        <Button
                                            id='setup_integration_corohealth_showpassword'
                                            onClick={() => this.handleShowPassword()}
                                            style={{ position: 'absolute', right: '1rem', bottom: '1rem', zIndex: '1', fontSize: 'medium', fontFamily: 'Gotham-Book' }}>
                                            {
                                                this.state.showPassword ? 'hide' : 'show'
                                            }
                                        </Button>
                                        <Field
                                            id='setup_integration_corohealth_password'
                                            name="coroHealth.password"
                                            label="Password"
                                            maxLength={20}
                                            inputClass='LsetupInfoSection'
                                            showPassword={this.state.showPassword}
                                            component={renderPasswordField}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    {/* WorxHub */}
                    <Grid item xs={5} sm={5} md={5} >
                        <Grid container direction='column'>
                            <Grid item xs={12} >
                                <Grid container className='LsetUpGridColum' direction='colum'>
                                    <Grid item xs={2} sm={2} md={2} style={{ padding: '10px', textAlign: 'right' }}>
                                        <Field
                                            idToSet='setup_integration_workhub_switch'
                                            name="worxHub.active"
                                            checked={this.state.worxHubActive}
                                            onClick={() => {
                                                this.setState((prevState) => (
                                                    { worxHubActive: !prevState.worxHubActive }))
                                            }}
                                            component={LrenderSwitch}
                                        />
                                    </Grid>
                                    <Grid item xs={9} sm={9} md={9} className="LVoiceTitle" style={{ padding: '10px', textAlign: 'left' }}>
                                        WorxHub
                                    </Grid>
                                    <Grid item xs={2} sm={2} md={2}>
                                    </Grid>
                                    <Grid item xs={9} style={{ padding: '10px' }}>
                                        <Field
                                            id='setup_integration_workhub_partnerid'
                                            name="worxHub.partnerId"
                                            label="Partner ID"
                                            maxLength={20}
                                            inputClass='setupInfoSection'
                                            component={renderLegacyTextField}
                                        />
                                    </Grid>
                                    <Grid item xs={2} sm={2} md={2}>
                                    </Grid>
                                    <Grid item xs={9} style={{ padding: '10px' }}>
                                        <Field
                                            id='setup_integration_workhub_partnerkey'
                                            name="worxHub.partnerKey"
                                            label="Partner Key"
                                            maxLength={20}
                                            inputClass='setupInfoSection'
                                            component={renderLegacyTextField}
                                        />
                                    </Grid>
                                    <Grid item xs={2} sm={2} md={2}>
                                    </Grid>
                                    <Grid item xs={9} style={{ padding: '10px' }}>
                                        <Field
                                            id='setup_integration_workhub_thwinstance'
                                            name="worxHub.thwInstance"
                                            label="THW Instance"
                                            maxLength={20}
                                            inputClass='setupInfoSection'
                                            component={renderLegacyTextField}
                                        />
                                    </Grid>
                                    <Grid item xs={2} sm={2} md={2}>
                                    </Grid>
                                    <Grid item xs={9} style={{ padding: '10px' }}>
                                        <Field
                                            id='setup_integration_workhub_thwinstance'
                                            name="worxHub.thwSite"
                                            label="THW Site"
                                            maxLength={20}
                                            inputClass='setupInfoSection'
                                            component={renderLegacyTextField}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    {/* TELS */}
                    <Grid item xs={5} sm={5} md={5} >
                        <Grid container direction='column'>
                            <Grid item xs={12} >
                                <Grid container className='LsetUpGridColum' direction='colum'>
                                    <Grid item xs={2} sm={2} md={2} style={{ padding: '10px', textAlign: 'right' }}>
                                        <Field
                                            idToSet='setup_integration_tels_switch'
                                            name="tels.active"
                                            checked={this.state.telsActive}
                                            onClick={() => {
                                                this.setState((prevState) => (
                                                    { telsActive: !prevState.telsActive }))
                                            }}
                                            component={LrenderSwitch}
                                        />
                                    </Grid>
                                    <Grid item xs={9} sm={9} md={9} className="LVoiceTitle" style={{ padding: '10px', textAlign: 'left' }}>
                                        TELS
                                    </Grid>
                                    <Grid item xs={2} sm={2} md={2}>
                                    </Grid>
                                    <Grid item xs={9} style={{ padding: '10px' }}>
                                        <Field
                                            id='setup_integration_tels_businessUnitId'
                                            name="tels.businessUnitId"
                                            label="Business Unit Id"
                                            maxLength={20}
                                            inputClass='setupInfoSection'
                                            component={renderLegacyTextField}
                                        />
                                    </Grid>
                                    <Grid item xs={2} sm={2} md={2}>
                                    </Grid>
                                    <Grid item xs={9} style={{ padding: '10px' }}>
                                        <Field
                                            id='setup_integration_tels_refreshToken'
                                            name="tels.refreshToken"
                                            label="Refresh Token"
                                            maxLength={20}
                                            inputClass='setupInfoSection'
                                            component={renderLegacyTextField}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </>
        )
    }

}

function mapStateToProps(state) {
    return {}
}


export default connect(mapStateToProps, {  UpdateCommunyV2})(reduxForm({
    form: 'ManagementIntegration',
    enableReinitialize: true
})(ManagementIntegration));